import { Link } from 'react-router-dom';
import { FadeUp } from './Motion.jsx';
import { IconGlobe, IconShield, IconDocument } from './Icons.jsx';
import worldMap from '../assets/images/worldmap.png';

export default function InfoStrip() {
  return (
    <FadeUp>
      <section className="infostrip" aria-label="Company information" id="adverse-event">
        <div className="infostrip-col" id="locations">
          <span className="infostrip-icon"><IconGlobe /></span>
          <div>
            <h3 className="infostrip-title">Global presence</h3>
            <p className="infostrip-text">Dublin, Jena, Vienna, France,<br />Malaysia and Latvia.</p>
          </div>
        </div>

        <div className="infostrip-col infostrip-col--map">
          <img src={worldMap} alt="" aria-hidden="true" />
        </div>

        <div className="infostrip-col">
          <span className="infostrip-icon"><IconShield /></span>
          <div>
            <h3 className="infostrip-title">Adverse event report</h3>
            <p className="infostrip-text">Regulatory reporting<br />and compliance access.</p>
            <Link to="/adverse-event-report" className="infostrip-link" aria-label="Read more about adverse event reporting">
            Read more <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>

        <div className="infostrip-col">
        <span className="infostrip-icon"><IconDocument /></span>
        <div>
          <h3 className="infostrip-title">Trusted &amp; approved</h3>
          <p className="infostrip-text">Part of the biolitec group.<br />Presence across 6 countries.</p>
          <Link to="/about" className="infostrip-link" aria-label="Learn more about biolitec Pharma">
          Learn more <span aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
      </section>
    </FadeUp>
  );
}